import { render, staticRenderFns } from "./AttributeSticker.vue?vue&type=template&id=38be78f0&scoped=true&"
import script from "./AttributeSticker.vue?vue&type=script&lang=ts&"
export * from "./AttributeSticker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be78f0",
  null
  
)

export default component.exports